import Store from '@ember-data/store';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { onTaskSavedOptionsArgs } from 'donor-elf-web/components/task/info';
import V2TaskModel from 'donor-elf-web/models/v2-task';
import AddSomethingModal, {
  type OpenArgs,
} from 'donor-elf-web/services/add-something-modal';
import TaskService from 'donor-elf-web/services/task-service';

interface ComponentArgs {
  openArgs?: OpenArgs;
}

export default class AddSomethingModalTaskIndexComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);
    this.createTask();
  }

  @service declare addSomethingModal: AddSomethingModal;
  @service declare store: Store;
  @service declare taskService: TaskService;

  @tracked task?: V2TaskModel;

  createTask() {
    this.task = this.taskService.createRecord();
    if (isPresent(this.args.openArgs?.taskOptions?.contactId)) {
      this.task.contactId = this.args.openArgs!.taskOptions!.contactId;
    } else if ((this.args.openArgs?.taskOptions?.contactIds?.length || 0) > 0) {
      this.task.contactIds = this.args.openArgs!.taskOptions!.contactIds;
    } else {
      this.task.contactId = this.addSomethingModal.currentContactId;
    }
    if (isPresent(this.args.openArgs?.taskOptions?.actionLabel)) {
      this.task.actionId =
        this.taskService.actionsByLabel[
          this.args.openArgs!.taskOptions!.actionLabel!
        ]?.id;
    }
  }

  @action
  handleTaskSaved(task: V2TaskModel, options?: onTaskSavedOptionsArgs) {
    this.addSomethingModal.taskAdded({ task });
    if (options?.addAnother === true) {
      this.createTask();
    } else {
      this.addSomethingModal.close();
    }
  }

  @action
  cancel() {
    this.addSomethingModal.close();
  }
}
